import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConnect = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.3708 4.12486C14.299 4.04491 14.2017 4 14.1002 4C13.9987 4 13.9013 4.04491 13.8295 4.12486L13.2883 4.72789C13.2166 4.80787 13.1762 4.91632 13.1762 5.02941C13.1762 5.14249 13.2166 5.25095 13.2883 5.33092L16.845 9.29412H3.38276C3.28125 9.29412 3.18389 9.33905 3.11211 9.41903C3.04033 9.49901 3 9.60748 3 9.72059V10.5735C3 10.6866 3.04033 10.7951 3.11211 10.8751C3.18389 10.9551 3.28125 11 3.38276 11H19.6173C19.693 11 19.767 10.975 19.8299 10.9281C19.8929 10.8812 19.9419 10.8146 19.9709 10.7367C19.9998 10.6588 20.0074 10.5731 19.9926 10.4904C19.9779 10.4076 19.9414 10.3317 19.8879 10.272L14.3708 4.12486Z",
		fill: "#4B525D",
		fillOpacity: .56
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.6172 14H3.38268C3.30699 14 3.233 14.025 3.17007 14.0719C3.10714 14.1188 3.0581 14.1854 3.02913 14.2633C3.00017 14.3412 2.99259 14.4269 3.00735 14.5096C3.02211 14.5924 3.05855 14.6683 3.11207 14.728L8.62923 20.8751C8.70101 20.9551 8.79835 21 8.89984 21C9.00134 21 9.09868 20.9551 9.17046 20.8751L9.71169 20.2721C9.78344 20.1921 9.82375 20.0837 9.82375 19.9706C9.82375 19.8575 9.78344 19.7491 9.71169 19.6691L6.15504 15.7059H19.6172C19.7188 15.7059 19.8161 15.661 19.8879 15.581C19.9597 15.501 20 15.3925 20 15.2794V14.4265C20 14.3134 19.9597 14.2049 19.8879 14.1249C19.8161 14.0449 19.7188 14 19.6172 14Z",
		fill: "#4B525D",
		fillOpacity: .56
	})]
});
export default SvgConnect;
